// extracted by mini-css-extract-plugin
export default {"main":"amount_main__aFIYG"};